<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/04_Chapter01"><span class="bold">Wheeled AFVs in US Service</span></a></h2>
<h2 class="toc"><a href="#/xhtml/05_Chapter02"><span class="bold">The Development of the Stryker</span></a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter03" title="Link target outside of Sample"><span class="bold">The Stryker Brigade Combat Team</span></span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter04" title="Link target outside of Sample"><span class="bold">Stryker Described Part 1</span></span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter05" title="Link target outside of Sample"><span class="bold">Camouflage and Markings</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter06" title="Link target outside of Sample"><span class="bold">Model Showcase</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter07" title="Link target outside of Sample"><span class="bold">Modelling Products</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter08" title="Link target outside of Sample"><span class="bold">Stryker Described Part 2</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter09" title="Link target outside of Sample"><span class="bold">LAV III</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter10" title="Link target outside of Sample"><span class="bold">NZLAV</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter11" title="Link target outside of Sample"><span class="bold">Stryker at War</span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Further" title="Link target outside of Sample"><span class="bold">Further Reading</span></span></h2>
<div class="boxc">
<p class="toct">Front cover left to right: Heavily laden Strykers of 2-14 Cavalry, 172nd SBCT, 25th Infantry Division, roll through Rawah in Iraq near the Syrian border in November 2005. (US Army photo by SSG Kyle Davis); a Canadian LAV III waits in a vehicle park in a snow-covered Kabul, Afghanistan, in 2004. (Patrick Winnepenninckx); an M1134 ATGMV moves through the Hohenfels Training Area in Germany during Exercise Saber Strike in October 2012. (US Army photo by Marcus Rauchenberger)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?3bf794b6